/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * PROSPECT (Prospekt): added but not approved yet, the default status of a new customer. REJECTED (Odrzucony klient): rejected with a reason by a person holding CUSTOMER_APPROVE. Both are entered and left only by the approval decisions (approve, reject, resubmit), never by the edit, which switches only between ACTIVE and INACTIVE. Only an ACTIVE customer can become the customer of a process.
 */

export const CustomerStatusDto = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Prospect: 'PROSPECT',
    Rejected: 'REJECTED',
} as const;

export type CustomerStatusDto = typeof CustomerStatusDto[keyof typeof CustomerStatusDto];



